import template from './index.html'
import {clone} from 'lodash'

config.$inject = ['formlyConfigProvider']
function config(formlyConfigProvider) {
  const type = {
    name: 'select',
    templateUrl: template,
    wrapper: ['bootstrapLabel', 'bootstrapHasError'],
    apiCheck: check => ({
      templateOptions: {
        options: check.arrayOf(check.object),
        optionsAttr: check.string.optional,
        labelProp: check.string.optional,
        valueProp: check.string.optional,
        groupProp: check.string.optional
      }
    })
  }
  formlyConfigProvider.setType(type)

  var gridType = clone(type, true)
  gridType.name = 'gridSelect'
  gridType.wrapper = ['bootstrapHasError']

  formlyConfigProvider.setType(gridType)
}

export default config